import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { trackByUuid } from '@nk/utils-lib';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CardContentComponent } from '../card/card-content/card-content.component';
import { CardComponent } from '../card/card/card.component';
import { HelpPopoverComponent } from '../help-popover/help-popover.component';
import { PaginationComponent } from '../pagination/pagination.component';
import { CardListItemComponent } from './card-list-item/card-list-item.component';
import {
  CardListSorts,
  EntityWithUuid,
  getNextSortDirection,
  NkCardListConfig,
  NkCardListData,
  NkCardListItemConfig,
} from './card-list.utils';

@Component({
  selector: 'nk-card-list',
  imports: [
    NgClass,
    CardListItemComponent,
    TranslateModule,
    CardComponent,
    CardContentComponent,
    PaginationComponent,
    HelpPopoverComponent,
    TooltipModule,
  ],
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListComponent<Entity extends EntityWithUuid> {
  public cardListConfig = input<NkCardListConfig<Entity> | undefined>();
  public data = input<NkCardListData<Entity>>();
  public isLoading = input(false);
  public noBorder = input(false);
  public andClass = input('');
  /**
   * True: Collapse button is shown. Set to true and collapse details will always be shown
   */
  public collapsibleDetails = input(true);
  public changePage = output<number>();
  public changeSorts = output<CardListSorts<Entity>>();
  public trackByUuid = trackByUuid;

  public onChangePage(page: number): void {
    this.changePage.emit(page);
  }

  public setSort(item: NkCardListItemConfig<Entity>): void {
    if (!item.sortable) {
      return;
    }
    const sorts: CardListSorts<Entity> = this.data()?.sorts || {};
    sorts[item.prop] = getNextSortDirection(sorts, item);
    // Explanation for the for-loop here:
    // Sorting on multiple columns has confused users, so we decided to have only 1 sort at a time.
    // i.e. when you set a column to sort on, the others switches off.
    for (const key of Object.keys(sorts)) {
      if (key !== item.prop) {
        sorts[key as keyof Entity] = undefined;
      }
    }
    this.changeSorts.emit(sorts);
  }
}
